<template>
  <div>
    <div :id="idGraph" v-tooltip="tooltipConstructor()"></div>
  </div>
</template>

<script>
import Plotly from "plotly.js-dist-min/plotly.min";

export default {
  data() {
    return {
      idGraph: "",
      chart: null,
      anterio: true,
      data: [
        {
          type: "indicator",
          mode: "number+gauge+delta",
          value: 85,
          domain: { x: [0, 1], y: [0, 1] },
          delta: { reference: 75, font: { size: 12 } },
          number: { font: { size: 39 } },
          gauge: {
            shape: "bullet",
            axis: { range: [0, 100], showticklabels: this.showTicks },
            threshold: {
              line: { color: "black", width: 4 },
              thickness: 0.75,
              value: 75,
            },
            steps: [
              { range: [0, 50], color: "#f4cdcd" },
              { range: [50, 60], color: "#fff2cc" },
              { range: [60, 80], color: "#d9ead3" },
              { range: [80, 90], color: "#a2c4c9" },
              { range: [90, 100], color: "#c8d9f7" },
            ],
            bar: { color: "black" },
            bordercolor: "white",
          },
        },
      ],
      nameValue: "Valor",
      nameLast: "Anterior",
    };
  },
  props: {
    dataGraph: {
      type: Object,
    },
    cambio: Number,
  },
  beforeMount() {
    if (this.dataGraph.data) {
      let data = this.dataGraph.data;

      if (data[0].target) {
        this.anterio = true;
      } else {
        this.anterio = false;
      }
      if (data[0].nameValue) {
        this.nameValue = data[0].nameValue;
      }
      if (data[0].nameLast) {
        this.nameLast = data[0].nameLast;
      }
    }
  },
  methods: {
    createdIdGraph() {
      this.idGraph = Math.random()
        .toString(36)
        .substr(2, 9);
    },
    render() {
      if (this.dataGraph.data) {
        let data = this.dataGraph.data;
        let layout = this.dataGraph.options.layout;
        let config = this.dataGraph.options.config;

        if (data[0].target) {
          this.anterio = true;
        } else {
          this.anterio = false;
        }

        if (this.chart) {
          Plotly.purge(this.idGraph.toString());
        }
        this.chart = Plotly.newPlot(
          this.idGraph.toString(),
          data,
          layout,
          config
        );
      }
    },
    tooltipConstructor() {
      if (this.dataGraph.data[0]) {
        return `
            <div>
              ${
                this.dataGraph.options.tooltip.title
                  ? `<span class="has-text-weight-bold">${this.dataGraph.options.tooltip.title}</span>`
                  : ""
              }
              <div class="is-flex is-size-6">
                <div
                  class="boxElementGraph"
                  style="background-color: ${
                    this.dataGraph.data[0].gauge.bar.color
                  } !important;"
                ></div>
                ${this.nameValue}: ${this.dataGraph.data[0].value.toFixed(2)}
              </div>
              ${
                this.anterio
                  ? `<div class="is-flex">
                  <div
                    class="boxElementGraph"
                    style="background-color: ${
                      this.dataGraph.data[0].gauge.threshold.line.color
                    } !important;"
                  ></div>
                  ${
                    this.nameLast
                  }: ${this.dataGraph.data[0].gauge.threshold.value.toFixed(1)}
                </div>`
                  : ""
              }
            </div>
        `;
      }
    },
  },
  created() {
    this.createdIdGraph();
  },
  mounted() {
    if (this.dataGraph) {
      this.render();
    }
  },
  watch: {
    cambio(newv, oldv) {
      if (this.dataGraph) {
        this.render();
      }
    },
  },
};
</script>
<style lang="scss">
.boxElementGraph {
  margin: auto 5px 5px 0;
  width: 16px !important;
  height: 16px !important;
  border: solid 1px black;
  background-color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/GraphBullet.vue